import CheckIcon from "@/components/icons/CheckIcon";
import TruckIcon from "@/components/icons/TruckIcon";

export default function ProgressStep({step, label, finished, current, goToStep}) {

    const handleClick = () => {
        if (finished) {
            goToStep(step)
        }
    }

    return (
        <li
            onClick={handleClick}
            className={`daisy-step ${finished ? 'cursor-pointer' : 'pointer-events-none'} ${finished || current ? 'daisy-step-primary' : 'daisy-step-secondary'} ${current ? 'daisy-step-current' : ''}`}
        >
            <span className={`daisy-step-icon`}>
                {!current && !finished && <>{step}</>}
                {!current && finished &&
                    <CheckIcon/>
                }
                {current && (
                    <>
                        <div className={"size-full hidden lg:!block"}>
                            <TruckIcon/>
                        </div>
                        <div className={"block lg:hidden"}>
                            <>{step}</>
                        </div>
                    </>
                )}
            </span>
            <div className={"hidden lg:!block"}>
                {label}
            </div>
        </li>
    )
}
